<script setup lang="ts">
import CampDetailsPage from '~/pages/camp-details.vue'

definePageMeta({
  layout: 'front-page',
  public: true,
})
</script>

<template>
  <CampDetailsPage />
</template>
